import { render, staticRenderFns } from "./login-bottom.vue?vue&type=template&id=e9bdd560&scoped=true"
import script from "./login-bottom.vue?vue&type=script&lang=js"
export * from "./login-bottom.vue?vue&type=script&lang=js"
import style0 from "./login-bottom.vue?vue&type=style&index=0&id=e9bdd560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bdd560",
  null
  
)

export default component.exports